import { FC } from 'react';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { EyeOutlined, FolderOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';

interface IProps {
  id: string;
  name: string;
}

const FolderItem: FC<IProps> = ({ id, name }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const onViewFolder = async () => {
    const page = searchParams.get('page');

    searchParams.set('page', `${page}/${id}`);
    setSearchParams(searchParams);
  };

  return (
    <>
      <Flex align="center" gap={16}>
        <span className="list-item-bg">
          <FolderOutlined style={{ fontSize: 16, color: 'var(--white)' }} />
        </span>
        <p>
          <span className="list-content-item-title">{t('patient.folder')}</span>
          <span className="list-content-item-value">{name}</span>
        </p>
      </Flex>
      <div style={{ width: 165, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          size="large"
          type="primary"
          icon={<EyeOutlined />}
          onClick={onViewFolder}
          style={{ width: '100%' }}
          ghost
        >
          {t('patient.view_folder')}
        </Button>
      </div>
    </>
  );
};

export default FolderItem;
